export default {
  myProfile: "Mein Profil",
  notificationSettings: "Benachrichtigungseinstellungen",
  userRegistration: "Benutzeregistrierung",
};
